import { Clock, Mail, Phone } from "lucide-react";
import { MARKETING_CONTACT } from "@/pages/marketing/marketing-content";

type Channel = {
  icon: typeof Mail;
  label: string;
  value: string;
  href?: string;
};

const CHANNELS: Channel[] = [
  {
    icon: Mail,
    label: "Email",
    value: MARKETING_CONTACT.email,
    href: `mailto:${MARKETING_CONTACT.email}`,
  },
  {
    icon: Phone,
    label: "Phone",
    value: MARKETING_CONTACT.phoneDisplay,
    href: `tel:${MARKETING_CONTACT.phoneTel}`,
  },
  {
    icon: Clock,
    label: "Response time",
    value: "Within 24 hours (Mon–Fri)",
  },
];

export function ContactChannels() {
  return (
    <aside className="rounded-lg border border-slate-200 bg-slate-50/80 p-5 sm:p-6">
      <h2 className="font-heading text-base font-semibold text-slate-900">
        Other ways to reach us
      </h2>
      <p className="mt-1 text-sm text-slate-500">
        Prefer email or phone? We’re available during business days.
      </p>

      <ul className="mt-5 space-y-4">
        {CHANNELS.map(({ icon: Icon, label, value, href }) => (
          <li key={label} className="flex gap-3">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-white text-primary shadow-sm ring-1 ring-slate-200/80">
              <Icon className="h-4 w-4" aria-hidden />
            </span>
            <div className="min-w-0">
              <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
              {href ? (
                <a
                  href={href}
                  className="mt-0.5 block truncate text-sm font-medium text-slate-900 transition-colors duration-200 hover:text-primary"
                >
                  {value}
                </a>
              ) : (
                <p className="mt-0.5 text-sm font-medium text-slate-900">{value}</p>
              )}
            </div>
          </li>
        ))}
      </ul>
    </aside>
  );
}
